import { useContext, useMemo } from "react";

import { ComboBox } from "@skydio/rivet-ui";

import { VehicleTypeCategoriesContext } from "../../common/VehicleTypeCategories";

import type { Key } from "@skydio/rivet-ui";

export interface VehicleTypeVehicleCategoryFilterProps {
  selectedKeys: Iterable<Key>;
  onSelectionChange: (keys: Set<Key>) => void;
}
const VehicleTypeVehicleCategoryFilter = (props: VehicleTypeVehicleCategoryFilterProps) => {
  const vehicleTypeCategoriesContext = useContext(VehicleTypeCategoriesContext);
  const categories = vehicleTypeCategoriesContext?.categories;

  const availableTypes = useMemo(() => {
    if (
      categories &&
      categories.vehicleTypeCategories &&
      categories.vehicleTypeCategories.vehicleTypes
    ) {
      return categories.vehicleTypeCategories.vehicleTypes.map(vtype => {
        return { name: vtype, key: vtype };
      });
    }
    return [];
  }, [categories]);

  return (
    <ComboBox
      selectionMode="multiple"
      placeholder="Select Vehicle Types"
      selectedKeys={props.selectedKeys}
      onSelectionChange={props.onSelectionChange}
      items={availableTypes}
      aria-label="Select Vehicle Types"
    >
      {data => (
        <ComboBox.Item key={data.key as string} aria-label={data.name ?? ""}>
          {data.name}
        </ComboBox.Item>
      )}
    </ComboBox>
  );
};

export default VehicleTypeVehicleCategoryFilter;
